import { getDateFormattedForEditing } from '../common/util/common';

export default interface FacilityDetails {
    id: string;
    name: string;
    contactDetails: string;
    streetAddressLine1: string;
    streetAddressLine2: string;
    suburb: string;
    state: string;
    postcode: string;
    halReference: number;
    repairPeriodStartDate: Date | undefined;
    repairPeriodEndDate: Date | undefined;
}
export interface FacilityOpenDates {
    facilityId: string;
    openFromDate: Date | null;
    shutDownDate: Date | null;
    checkForExistingBookings?: boolean;
}
export class FacilityOpenDatesFormValues {
    facilityId: string = '';
    openFromDate: Date | null = null;
    shutDownDate: Date | null = null;
    checkForExistingBookings?: boolean = true;

    constructor(facilityOpenDates?: FacilityOpenDates) {
        if (facilityOpenDates) {
            this.facilityId = facilityOpenDates.facilityId;
            this.openFromDate = facilityOpenDates.openFromDate;
            this.shutDownDate = facilityOpenDates.shutDownDate;
            this.checkForExistingBookings = facilityOpenDates.checkForExistingBookings;
        }
    }
}
export interface CapacityConfigEntryForAWeekday {
    weekDay: string;
    capacityItems: CapacityConfigEntry[];
}
export interface CapacityConfigEntry {
    repairType: string;
    capacity: number;
}
export interface FacilityRepairCapacity {
    facilityId: string;
    appliesToWeekStarting?: Date;
    configEntriesForTheWeek: CapacityConfigEntryForAWeekday[];
}
export class FacilityRepairCapacityFormValues {
    facilityId: string = '';
    configEntriesForTheWeek: CapacityConfigEntryForAWeekday[] = [];
    appliesToWeekStarting?: Date = undefined;
    checkCapacityAgainstExistingBookings?: boolean = true;

    constructor(facilityRepairCapacity?: FacilityRepairCapacity) {
        if (facilityRepairCapacity) {
            this.facilityId = facilityRepairCapacity.facilityId;
            this.configEntriesForTheWeek = [...facilityRepairCapacity.configEntriesForTheWeek];
            if (facilityRepairCapacity.appliesToWeekStarting)
                this.appliesToWeekStarting = facilityRepairCapacity.appliesToWeekStarting;
        }
    }
}

export interface FacilityWaitlist {
    facilityId: string;
    enable: Boolean | null;
    pdrSendWaitlistOffers: Boolean | null;
    ptpSendWaitlistOffers: Boolean | null;
    conSendWaitlistOffers: Boolean | null;
    pdrRatio: number | null;
    ptpRatio: number | null;
    conRatio: number | null;
    waitlistEndDate: Date | null;
    waitlistEnabledOn: Date | null;
    waitlistlastRunDate: Date | null;
    waitlistnextRunDate: Date | null;
}

export class FacilityWaitlistFormValues {
    facilityId: string = '';
    enable: Boolean | null = null;
    pdrSendWaitlistOffers: Boolean | null = null;
    ptpSendWaitlistOffers: Boolean | null = null;
    conSendWaitlistOffers: Boolean | null = null;
    pdrRatio: number | null = null;
    ptpRatio: number | null = null;
    conRatio: number | null = null;
    waitlistEndDate: string | null = null;

    constructor(facilityWaitlist?: FacilityWaitlist) {
        if (facilityWaitlist) {
            console.log(facilityWaitlist);
            this.facilityId = facilityWaitlist.facilityId;
            this.enable = facilityWaitlist.enable;
            this.pdrSendWaitlistOffers = facilityWaitlist.pdrSendWaitlistOffers;
            this.ptpSendWaitlistOffers = facilityWaitlist.ptpSendWaitlistOffers;
            this.conSendWaitlistOffers = facilityWaitlist.conSendWaitlistOffers;
            this.pdrRatio = facilityWaitlist.pdrRatio;
            this.ptpRatio = facilityWaitlist.ptpRatio;
            this.conRatio = facilityWaitlist.conRatio;
            //this.waitlistEndDate = facilityWaitlist.waitlistEndDate;
            this.waitlistEndDate = facilityWaitlist.waitlistEndDate
                ? getDateFormattedForEditing(facilityWaitlist.waitlistEndDate)
                : null;

            //debugger;
            console.log(`facilityId: ${facilityWaitlist.facilityId}`);
            console.log(`enable: ${facilityWaitlist.enable}`);
            console.log(`pdrSendWaitlistOffers: ${facilityWaitlist.pdrSendWaitlistOffers}`);
            console.log(`ptpSendWaitlistOffers: ${facilityWaitlist.ptpSendWaitlistOffers}`);
            console.log(`conSendWaitlistOffers: ${facilityWaitlist.conSendWaitlistOffers}`);
            console.log(`pdr ratio: ${facilityWaitlist.pdrRatio}`);
            console.log(`end date: ${this.waitlistEndDate}`);
            console.log(`enabled date: ${facilityWaitlist.waitlistEnabledOn}`);
        }
    }
}

export interface FacilityCloseDate {
    facilityId: string;
    closureDate: Date | null;
    allowClosureOnTheDayBookingsExist?: boolean;
    checkForExistingBookings?: boolean;
}
export class FacilityCloseDateFormValues {
    facilityId: string = '';
    closureDate: Date | null = null;
    allowClosureOnTheDayBookingsExist?: boolean = true;
    //checkForExistingBookings?: boolean = true;

    constructor(facilityCloseDate?: FacilityCloseDate) {
        if (facilityCloseDate) {
            this.facilityId = facilityCloseDate.facilityId;
            this.closureDate = facilityCloseDate.closureDate;
            this.allowClosureOnTheDayBookingsExist = facilityCloseDate.allowClosureOnTheDayBookingsExist;
        }
    }
}

export interface FacilityDropoffTimeSetting {
    id: string; //drop off window id
    facilityId: string;
    startTimeOfDropOffWindow: string | null; //examples 07:00 (= 7am), 13:00 (= 1pm)
    endTimeOfDropOffWindow: string | null; //examples 07:00 (= 7am), 13:00 (= 1pm)
    timeIntervalInMinutes: string | null; //examples 00:15 (= 15 mins), 00:40 (= 40 mins)
    allowance: DropoffAllowance[] | null;
}

export interface DropoffAllowance {
    dropoffTimeSlot: string | null;
    dropoffsAllowed: number;
}

export class FacilityDropoffTimeSettingFormValues {
    id: string = ''; //drop off window id
    facilityId: string = '';
    startTimeOfDropOffWindow: string | null = null;
    endTimeOfDropOffWindow: string | null = null;
    timeIntervalInMinutes: string | null = null;
    allowance: DropoffAllowance[] | null = null;

    constructor(facilityDropoffTimeSetting?: FacilityDropoffTimeSetting) {
        if (facilityDropoffTimeSetting) {
            this.id = facilityDropoffTimeSetting.id;
            this.facilityId = facilityDropoffTimeSetting.facilityId;
            this.startTimeOfDropOffWindow = facilityDropoffTimeSetting.startTimeOfDropOffWindow;
            this.endTimeOfDropOffWindow = facilityDropoffTimeSetting.endTimeOfDropOffWindow;
            this.timeIntervalInMinutes = facilityDropoffTimeSetting.timeIntervalInMinutes;
            this.allowance = facilityDropoffTimeSetting.allowance;
        }
    }
}

export interface FacilityCapacityMetricForAWeek {
    startDateOfWeek: Date;
    capacityOfWeek: CapacityMetricLineItem[];
    closedDatesInTheWeek: Date[];
}

export interface CapacityMetricLineItem {
    repairType: string;
    capacity: number;
}

export interface FacilityClosedDatesForAWeek {
    startDateOfWeek: Date;
    closedDaysInTheWeek: Date[];
}

export interface FacilityRepairSeasonSummaryData {
    PDR: number;
    PTP: number;
    CON: number;
    grandTotal: number;
    numberOfClosedDays: number;
}

export interface FacilityCapacityCopyRequest {
    facilityId: string;
    startDateOfWeekToCopy: Date;
    weeksToCopyInto: Date[];
}

export interface FacilityLeadTime {
    facilityId: string;
    pdrLeadTimeInDays: number | null;
    ptpLeadTimeInDays: number | null;
    conLeadTimeInDays: number | null;
}

export class FacilityLeadTimeFormValues {
    facilityId: string = '';
    pdrLeadTimeInDays: number | null = null;
    ptpLeadTimeInDays: number | null = null;
    conLeadTimeInDays: number | null = null;

    constructor(facilityLeadTime?: FacilityLeadTime) {
        if (facilityLeadTime) {
            console.log(facilityLeadTime);
            this.facilityId = facilityLeadTime.facilityId;
            this.pdrLeadTimeInDays = facilityLeadTime.pdrLeadTimeInDays;
            this.ptpLeadTimeInDays = facilityLeadTime.ptpLeadTimeInDays;
            this.conLeadTimeInDays = facilityLeadTime.conLeadTimeInDays;
        }
    }
}


export interface FacilityDropoffMetricForAWeekDay {
    weekDay: string;
    totalDropoffs: number;
    dropoffWindows: DropoffWindowSummary[]|null;
}

export interface DropoffWindowSummary {
    id: string, //drop off window id
    startTime: string,
    endTime: string,
    intervalInMinutes: number,
    totalDropoffs: number,
}
